import { createConfirmSlot } from '#design-tokenomics/utils/confirm-slot'

export interface DesignConfirmOptions {
  title: string
  description?: string
  confirmLabel?: string
  cancelLabel?: string
}

interface DesignConfirmState extends DesignConfirmOptions {
  isOpen: boolean
}

const CLOSED: DesignConfirmState = { isOpen: false, title: '' }

const state = ref<DesignConfirmState>({ ...CLOSED })

const slot = createConfirmSlot<DesignConfirmOptions>((options) => {
  state.value = options ? { ...options, isOpen: true } : { ...state.value, isOpen: false }
})

export function useDesignConfirm() {
  return {
    state: readonly(state),
    confirm: slot.ask,
    answer: slot.answer,
  }
}
